import { render, staticRenderFns } from "./TableQuantityCounter.vue?vue&type=template&id=b0591a5a&scoped=true"
import script from "./TableQuantityCounter.vue?vue&type=script&lang=js"
export * from "./TableQuantityCounter.vue?vue&type=script&lang=js"
import style0 from "./TableQuantityCounter.vue?vue&type=style&index=0&id=b0591a5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0591a5a",
  null
  
)

export default component.exports